var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{staticClass:"pmis-header d-none d-sm-none d-md-none d-lg-block"}),_c('b-col',{staticClass:"pmis-header-repeat"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }